<template>
  <div class="form-config-wrapper">
    <v-form ref="form" v-model="formDatos" class="dark-form">
      <!-- Logo -->
      <div class="logo-section">
        <div class="logo-preview">
          <img :src="imagenUrl" alt="Logo del gimnasio" />
        </div>
        <div class="logo-field">
          <label class="field-label">Logo</label>
          <v-file-input
            :rules="reglaImagen"
            accept="image/png, image/jpeg, image/bmp"
            placeholder="Selecciona una imagen"
            prepend-icon="mdi-camera"
            outlined
            dense
            hide-details="auto"
            v-model="imagen"
            class="dark-input"
            @change="onSeleccionarImagen"
          ></v-file-input>
        </div>
      </div>

      <div class="section-divider"></div>

      <div class="field">
        <label class="field-label">Nombre del gimnasio</label>
        <v-text-field
          :rules="reglasForm"
          v-model="datos.nombre"
          outlined
          dense
          hide-details="auto"
          placeholder="Ej. Bamboo Gym"
          class="dark-input"
        ></v-text-field>
      </div>

      <div class="field">
        <label class="field-label">Teléfono</label>
        <v-text-field
          :rules="reglasForm"
          v-model="datos.telefono"
          outlined
          dense
          hide-details="auto"
          placeholder="Ej. 3531015780"
          class="dark-input"
        ></v-text-field>
      </div>

      <div class="field">
        <label class="field-label">Dirección</label>
        <v-text-field
          :rules="reglasForm"
          v-model="datos.direccion"
          outlined
          dense
          hide-details="auto"
          placeholder="Calle, número, colonia"
          class="dark-input"
        ></v-text-field>
      </div>
    </v-form>

    <div class="form-actions">
      <button class="btn-primary" :disabled="!formDatos" @click="registrar">
        Registrar
      </button>
    </div>
  </div>
</template>

<script>
import Utiles from '../../Servicios/Utiles'
export default {
  name: "FormConfiguracion",
  props: ["ajustes"],

  data: () => ({
    formDatos: false,
    imagenUrl: null,
    imagen: null,
    datos: {
      nombre: "",
      telefono: "",
      direccion: "",
    },
    reglasForm: [(value) => !!value || "Debes colocar este campo."],
    reglaImagen: [
      (value) =>
        !value || value.size < 5000000 || "La foto debe pesar menos de 5 MB!",
    ],
  }),

  mounted() {
    this.datos = this.ajustes
    this.imagenUrl = Utiles.generarURL(this.ajustes.logo)
  },

  methods: {
    registrar() {
      this.datos.logo = this.imagenUrl

      this.$emit("registrar", this.datos)
    },

    crearImagen(imagen) {
      const reader = new FileReader()

      reader.onload = e => {
        this.imagenUrl = e.target.result
      }
      reader.readAsDataURL(imagen)
    },

    onSeleccionarImagen() {
      if (!this.imagen) {
        return
      }
      this.crearImagen(this.imagen);
    }
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.form-config-wrapper {
  --bg: #0E0E10;
  --card: #17171A;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --accent: #C8FF4D;
  --error: #FF6B6B;
  --radius: 4px;

  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  font-family: var(--font-body);
}

.dark-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* ===== LOGO ===== */
.logo-section {
  display: flex;
  align-items: center;
  gap: 18px;
}

.logo-preview {
  width: 72px;
  height: 72px;
  border-radius: var(--radius);
  border: 1px solid var(--card-border);
  background: var(--bg);
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.logo-field {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.section-divider {
  height: 1px;
  background: var(--card-border);
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--text-secondary);
  text-transform: uppercase;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 22px;
  padding-top: 20px;
  border-top: 1px solid var(--card-border);
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: var(--bg);
  border: none;
  border-radius: var(--radius);
  padding: 11px 22px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-primary:hover:not(:disabled) {
  filter: brightness(1.08);
}

.btn-primary:disabled {
  opacity: 0.45;
  cursor: default;
}

/* ===== Overrides v-text-field / v-file-input (Vuetify) ===== */
.dark-input >>> .v-input__slot {
  background: var(--bg) !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  min-height: 42px !important;
}

.dark-input >>> fieldset {
  border-color: var(--card-border) !important;
  border-width: 1px !important;
  border-radius: 4px !important;
  transition: border-color 0.15s ease;
}

.dark-input >>> .v-input--is-focused fieldset {
  border-color: var(--accent) !important;
  border-width: 1.5px !important;
}

.dark-input >>> input,
.dark-input >>> .v-file-input__text {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 14px !important;
  caret-color: var(--accent) !important;
}

.dark-input >>> input::placeholder {
  color: var(--text-tertiary) !important;
  opacity: 1 !important;
}

.dark-input >>> .v-icon {
  color: var(--text-tertiary) !important;
}

.dark-input >>> .v-messages {
  color: var(--error) !important;
}

.dark-input >>> .v-chip {
  background: rgba(200, 255, 77, 0.12) !important;
  color: var(--accent) !important;
}

@media (max-width: 500px) {
  .logo-section {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Configuracion/FormConfiguracion.vue